(function ( $ ) {
 
    $.fn.scrollActive = function() {
    	var elements = [],
			$el = $(this);

		$el.each(function(){
			var $trigger = $(this),
				offset = $trigger.offset().top;

			if (wb >= offset) {
				$trigger.addClass('active');
			} else {
				elements.push({
					'trigger': $trigger, 
					'offset': offset,
				});
			};
		});

        return $(window).scroll(function(){
        	$(".js-fade-out").css("opacity", 1 - $(window).scrollTop() / 150);

        	elements.map(function(elem, i){
				if (wb >= elem.offset) {
					elem.trigger.addClass('active');
					// elements.splice(i, 1);
                    var that = elements.indexOf(elem);
				};
			});
        });
    };
 
}( jQuery ));

$(function(){

	var timeout = setTimeout(function(){
		$('.js-scroll-active').scrollActive();
	}, 100);
});






// (function($) {

//   /**
//    * Copyright 2012, Digital Fusion
//    * Licensed under the MIT license.
//    * http://teamdf.com/jquery-plugins/license/
//    *
//    * @author Sam Sehnert
//    * @desc A small plugin that checks whether elements are within
//    *     the user visible viewport of a web browser.
//    *     only accounts for vertical position, not horizontal.
//    */

//   $.fn.visible = function(partial) {
    
//       var $t            = $(this),
//           $w            = $(window),
//           viewTop       = $w.scrollTop(),
//           viewBottom    = viewTop + $w.height(),
//           _top          = $t.offset().top,
//           _bottom       = _top + $t.height(),
//           compareTop    = partial === true ? _bottom : _top,
//           compareBottom = partial === true ? _top : _bottom;
    
//     return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

//   };
    
// })(jQuery);

// var win = $(window);

// var allMods = $(".js-scroll-active");

// allMods.each(function(i, el) {
//   var el = $(el);
//   if (el.visible(true)) {
//     el.addClass("active"); 
//   } 
// });

// win.scroll(function(event) {
//     $(".js-fade-out").css("opacity", 1 - $(window).scrollTop() / 150);
  
//     allMods.each(function(i, el) {
//     	// console.log('here' + i)
//     var el = $(el);
//     if (el.visible(true)) {
//       el.addClass("active"); 
//     } 
//     });
  
// });